import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import MeetTheTeam from "./sections/MeetTheTeam";
import WhyChooseUsCta from "./sections/WhyChooseUsCta";
import Footer from "@/reusable_sections/Footer";
import OurValues from "./sections/OurValues";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStory />
      <OurValues />
      <MeetTheTeam />
      <WhyChooseUsCta />
      <Footer />
    </div>;
}